import React, { useEffect, useState } from 'react';
import Boton from '../components/boton';
import { faCalendar } from '@fortawesome/free-solid-svg-icons';
import { formPopup } from '../components/popup';
import { getFeriados } from '../services/data.service';

const SCOPE_GLOBAL = 'Para todos los profesionales';

function isGlobalProf (prof) {
    return prof === undefined || prof === null || prof === '' || typeof prof === 'number';
}

function profDisplayLabel (prof) {
    return isGlobalProf(prof) ? SCOPE_GLOBAL : prof;
}

export default function ShowFeriados () {
    const show = () => {
        formPopup({
            title: 'Feriados',
            form: <ListFeriados />,
            textConfirm: 'Cerrar',
            width: 1000,
            customClass: {
                htmlContainer: 'text-left max-w-full px-0'
            }
        });
    };
    return (
        <Boton
            icono={faCalendar}
            estilo="mt-6 h-fit w-fit justify-self-end min-w-[2.75rem] min-h-[2.75rem]"
            ide="btnFeriados"
            color="bg-orange-500 hover:bg-orange-600"
            onClick={show}
            ariaLabel="Ver feriados registrados"
            title="Ver feriados"
        />
    );
}

function ListFeriados () {
    const [feriados, setFeriados] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let cancelled = false;
        const load = async () => {
            setLoading(true);
            const list = await getFeriados();
            if (!cancelled) {
                setFeriados(Array.isArray(list) ? list : []);
                setLoading(false);
            }
        };
        load();
        return () => {
            cancelled = true;
        };
    }, []);

    if (loading) {
        return (
            <div className="flex flex-col items-center justify-center gap-3 py-12 text-slate-600" role="status">
                <div
                    className="h-9 w-9 animate-spin rounded-full border-2 border-orange-500 border-t-transparent"
                    aria-hidden
                />
                <p className="text-sm">Cargando feriados…</p>
            </div>
        );
    }

    if (feriados.length === 0) {
        return (
            <div className="rounded-lg border border-dashed border-slate-200 bg-slate-50 px-4 py-8 text-center">
                <p className="text-sm text-slate-600">No hay feriados registrados para el año en curso.</p>
            </div>
        );
    }

    return (
        <ul className="max-h-[min(28rem,62vh)] space-y-3 overflow-y-auto pr-1 text-left [-webkit-overflow-scrolling:touch]">
            {feriados.map((feriado) => {
                const global = isGlobalProf(feriado.prof);
                const scopeLabel = profDisplayLabel(feriado.prof);
                const chipClass = global
                    ? 'border border-orange-200/90 bg-orange-50 text-orange-950'
                    : 'border border-slate-200 bg-slate-100 text-slate-800';
                return (
                    <li
                        key={feriado.id}
                        className="rounded-lg border border-slate-200/90 bg-white p-3 shadow-sm transition-shadow hover:shadow-md"
                    >
                        <div className="flex flex-col gap-2 sm:flex-row sm:items-start sm:justify-between sm:gap-3">
                            <div className="min-w-0 flex-1 space-y-1">
                                <p className="text-xs font-semibold uppercase tracking-wide text-slate-500 tabular-nums">
                                    {feriado.fecha}
                                </p>
                                <p className="text-base font-medium leading-snug text-slate-900">
                                    {feriado.titulo}
                                </p>
                            </div>
                            <span
                                className={
                                    'inline-flex shrink-0 self-start rounded-full px-2.5 py-1 text-xs font-medium leading-tight ' +
                                    chipClass
                                }
                            >
                                {scopeLabel}
                            </span>
                        </div>
                    </li>
                );
            })}
        </ul>
    );
}
